export default "__VITE_ASSET__B3LEdl6j__"